import { render } from "./wordTable.vue?vue&type=template&id=5bbe8159&scoped=true"
import script from "./wordTable.vue?vue&type=script&lang=js"
export * from "./wordTable.vue?vue&type=script&lang=js"

import "./wordTable.vue?vue&type=style&index=0&id=5bbe8159&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbe8159"]])

export default __exports__